export default function GetSellerPotentialService($http) {
  'ngInject';

  return function (requestId) {
    console.warn(
      'The getSellerPotentialService has been deprecated and will be removed from a future release.'
    );

    return $http.get(
      '/aptitude/buyer/SellerPricingComparisonServiceController/getSellerPotential',
      { params: { requestId: requestId }, intercept: true, cache: true }
    );
  };
}
